<template>
  <div class="events-todo">
    <Title :img="triangleImg" :name="'待处理事件'" :callback="onDetail"/>
    <div class="events-todo-content">
      <div class="scroll-container">
        <!-- 原始列表 -->
        <template v-for="(item, key) in eventsTodoList" :key="'original-'+key">
          <EventInfo :item="item"/>
        </template>
        <!-- 复制的列表，用于无缝滚动 -->
        <template v-for="(item, key) in eventsTodoList" :key="'duplicate-'+key">
          <EventInfo :item="item"/>
        </template>
      </div>
    </div>
  </div>

</template>

<script>
import Title from '@/components/title/title.vue'
import triangleImg from '@/assets/image/triangle.png'
import EventInfo from './EventInfo.vue'

export default {
  name: 'EventsTodo',
  components: {Title, EventInfo},
  data() {
    return {
      triangleImg: triangleImg,
      eventsTodoList: [
        {
          name: '西区垃圾分类点超量堆积',
          handler: '环境组-王洁',
          date: '2025-06-15',
          source: '保洁员巡查报告'
        },
        {
          name: 'B2停车场违规占位',
          handler: '安保部-李队长',
          date: '2025-06-16',
          source: '自动监测系统'
        },
        {
          name: 'A3道路井盖破损',
          handler: '工程部-刘强',
          date: '2025-06-17',
          source: '巡逻员发现'
        },
        {
          name: '中央草坪斑秃需补种',
          handler: '绿化队-张园艺',
          date: '2025-06-18',
          source: '自动监测系统'
        },
        {
          name: '5号楼车辆未按停车线停放',
          handler: '陈主任',
          date: '2025-06-19',
          source: '自动监测系统'
        },
        {
          name: '西门门禁系统故障',
          handler: '科技部周工',
          date: '2025-06-20',
          source: '门岗值班记录'
        }
      ]
    }
  },
  methods: {
    onDetail() {
      // 跳转到事件中心页面，并带上待处理状态作为筛选条件
      this.$router.push({ 
        path: "/events-center", 
        query: { 
          status: 10 // 10表示待处理状态
        } 
      });
    },
  }
}
</script>

<style lang="less" scoped>
.events-todo {
  position: relative;
  height: 50%;
  width: 100%;
  border-radius: 5px;
  padding: 0.5rem;
  background: /* 左上角圆形渐变 */ radial-gradient(circle at left top, #c8aca2, #171e2127 5%) no-repeat,
    /* 右上角圆形渐变 */ radial-gradient(circle at right top, #c8aca2, #171e2127 5%) no-repeat,
    /* 中间半透明背景 */ linear-gradient(to bottom, #171e2127, #171e2127);

  .events-todo-content {
    height: calc(100% - 40px); // 减去标题的高度
    overflow: hidden;
    position: relative;

    &:hover .scroll-container {
      animation-play-state: paused; // 鼠标悬停时暂停滚动
    }

    .scroll-container {
      animation: scroll 20s linear infinite; // 20秒完成一次循环，可以根据需要调整
      position: absolute;
      width: 100%;
    }
  }
}

@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%); // 向上滚动一半的距离
  }
}
</style>